<template>
  <section class="getting-started-section grey-bg">
    <div class="container">
      <SectionHeader
        title="Getting Started in TNA"
        :description="description"
      />
    </div>
    <div class="feature-list">
      <Card
        :item="item"
        v-for="(item, index) in data"
        :key="index"
        :extraClass="item.class ? item.class : ''"
      />
    </div>
  </section>
</template>

<script>
import SectionHeader from "@/pageComponents/globalUi/section-header";
import Card from "@/pageComponents/globalUi/cards/image-overlay-card";
export default {
  name: "GettingStarted",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    description: {
      type: String,
      default: ""
    }
  },
  methods: {},
  components: {
    SectionHeader,
    Card
  }
};
</script>

<style lang="scss">
.getting-started-section {
  padding-bottom: 0;
  .feature-list {
    display: flex;
    flex-wrap: wrap;
    > div {
      width: 33.33%;
    }
  }
}
@media only screen and (max-width: 575px) {
  .getting-started-section {
    .feature-list {
      > div {
        width: 100%;
      }
    }
  }
}
</style>
